import React from 'react';

import { attemptRegistration } from 'RLX/State/Auth/AuthActions';
import AuthFormController from 'RLX/Controllers/AuthFormController';

class RegistrationForm extends AuthFormController {
  constructor (props) {
    super(props);
    const { confirm } = props.confirm
      ? props
      : this.state.confirm
        ? this.state
        : { confirm: '' };
    this.state = { ...this.state, confirm };
    this.handleConfirmChange = this.handleConfirmChange.bind(this);
  }

  handleConfirmChange (confirm) {
    this.setState({ confirm });
  }

  getFields () {
    const { email, pass, name, confirm } = this.state;
    const { handleEmailChange, handlePassChange, handleNameChange, handleConfirmChange } = this;
    return [
      {
        label: 'Name',
        icon: 'user',
        type: 'text',
        value: name,
        onChange: handleNameChange,
        required: true,
        validate: 'name'
      },
      {
        label: 'Email',
        icon: 'envelope-open',
        type: 'text',
        value: email,
        onChange: handleEmailChange,
        required: true,
        validate: 'email'
      },
      {
        label: 'Password',
        secret: true,
        icon: 'key',
        type: 'text',
        value: pass,
        onChange: handlePassChange,
        required: true,
        validate: 'pass'
      },
      {
        label: 'Confirm Password',
        secret: true,
        icon: 'unlock-alt',
        type: 'text',
        value: confirm,
        onChange: handleConfirmChange,
        required: true,
        validatorMessage: 'The passwords do not match.',
        validate: (candidate) => candidate === pass
      }
    ];
  }

  getButtons () {
    const isSubmittable = this.isSubmittable();
    return [
      {
        className: 'subtle',
        url: '/RLX/Login',
        icon: 'lock',
        iconSide: 'right',
        text: 'Login'
      },
      {
        submit: true,
        when: isSubmittable,
        iconSide: 'right',
        text: 'Register',
        icon: 'motorcycle'
      }
    ];
  }


  handleSubmit ({ name, email, pass }) {
    attemptRegistration({ name, email, pass });
  }
};

export default RegistrationForm;



// WEBPACK FOOTER //
// ./client/RLX/Views/Auth/Forms/RegistrationForm.jsx